import { Chart as ChartJS, CategoryScale, LinearScale, PointElement, LineElement, Tooltip, Filler } from "chart.js";

/**
 * Register only the chart components we need
 * Maybe if the number of charts increases we should instaciate this file at the root of the app
 * https://www.chartjs.org/docs/latest/getting-started/integration.html#bundle-optimization
 */
ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Tooltip, Filler);
